import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { selectCountryOptions } from '../../../redux/data/selectors';
import {
  selectSavedPatientContacts,
  selectSavedPatientPersonalInfo,
  selectSavedPatientAddress,
} from '../../../redux/profiles/selectors';
import { loggedUserSelector } from '../../../redux/context/selectors';
import styles from '../PatientRegistrationInfo/index.styl';

const mapStateToProps = state => ({
  personalInfo: selectSavedPatientPersonalInfo(state),
  patientContacts: selectSavedPatientContacts(state),
  patientAddress: selectSavedPatientAddress(state),
  loggedUser: loggedUserSelector(state),
  countries: selectCountryOptions(state),
});

export const enhance = compose(
  connect(
    mapStateToProps,
    null,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationAddress/enhance.js